import script from "./AddNewChartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewChartModal.vue?vue&type=script&setup=true&lang=js"

import "./AddNewChartModal.vue?vue&type=style&index=0&id=6d640d7c&lang=scss"

const __exports__ = script;

export default __exports__